// International Features
//
// This file should not contain any strings that require translations.
// Only settings and numbers that vary between countries.
//
// All these keys will be added as translatable strings so you can
// references the same was you do translated strings.

export default {
  default: {
    feeTypes: [{
      value: 'sales_tax',
      labelKey: 'defaultSalesTax'
    }],
    feeInclusionType: 'INCLUSIVE',
    roundingType: 'BANKERS',
    bankAccountTypes: ['checking', 'businessChecking', 'savings'],
    accountOwnerRoles: ['businessOwnerOrBusiness', 'coOwnerOrBusinessPartner', 'beneficialOwnerDirectorOrSimilar', 'ownerSpouseOrDomesticPartner', 'other'],
    shipping: 'other',
    rates: {
      swipe: 0,
      keyed: {
        percent: 0,
        constant: 0
      },
      market: 0
    },
    closeOfDayHour: 17,
    // 5PM
    closeOfDayTimeZone: 'America/Los_Angeles',
    hasDepositAndWithdrawVerification: true,
    shouldHaveMinimumBalance: true,
    shouldSplitNameFields: false,
    hasExtraBusinessNameFields: false,
    shouldShowCanadianReceiptInfo: false,
    shouldShowGreatBritainReceiptInfo: false,
    canSelectStateForProfile: false,
    canQuerySplitDeposits: true,
    canViewSubscriptions: true,
    canSeeHardwareUpsell: true,
    shouldSeeMagstripe: true,
    canUseR12: false,
    canVerifyBankIn2Days: false,
    canVerifyBankIn5Days: true,
    canDepositInBankByNextDay: true,
    cannotDepositInBankByNextDay: false,
    canUseSameDayDeposits: false,
    canUseWeekendBalance: false,
    cannotSetReceiptsLanguage: false,
    canSetReceiptsLanguage: true,
    canSeeTransactionTaxTable: false,
    shouldShowPostalCodeFieldForCards: true,
    activeLanguages: ['ca', 'en', 'es', 'fr', 'pt', 'ja'],
    timezoneSelections: [{
      labelKey: 'timezone_offset_negative_1200',
      value: 'Pacific/Majuro',
      offset: -43200
    }, {
      labelKey: 'timezone_offset_negative_1100',
      value: 'Pacific/Pago_Pago',
      offset: -39600
    }, {
      labelKey: 'timezone_offset_negative_1000',
      value: 'Pacific/Honolulu',
      offset: -36000
    }, {
      labelKey: 'timezone_offset_negative_0930',
      value: 'Pacific/Marquesas',
      offset: -34200
    }, {
      labelKey: 'timezone_offset_negative_0900',
      value: 'America/Anchorage',
      offset: -32400
    }, {
      labelKey: 'timezone_offset_negative_0800',
      value: 'America/Los_Angeles',
      offset: -28800
    }, {
      labelKey: 'timezone_offset_negative_0700',
      value: 'America/Denver',
      offset: -25200
    }, {
      labelKey: 'timezone_offset_negative_0700_nodst',
      value: 'America/Phoenix',
      offset: -25200
    }, {
      labelKey: 'timezone_offset_negative_0600',
      value: 'America/Chicago',
      offset: -21600
    }, {
      labelKey: 'timezone_offset_negative_0500',
      value: 'America/New_York',
      offset: -18000
    }, {
      labelKey: 'timezone_offset_negative_0430',
      value: 'America/Caracas',
      offset: -16200
    }, {
      labelKey: 'timezone_offset_negative_0400',
      value: 'America/Halifax',
      offset: -14400
    }, {
      labelKey: 'timezone_offset_negative_0400_nodst',
      value: 'America/Puerto_Rico',
      offset: -14400
    }, {
      labelKey: 'timezone_offset_negative_0330',
      value: 'America/St_Johns',
      offset: -12600
    }, {
      labelKey: 'timezone_offset_negative_0300',
      value: 'America/Argentina/Buenos_Aires',
      offset: -10800
    }, {
      labelKey: 'timezone_offset_negative_0200',
      value: 'America/Noronha',
      offset: -7200
    }, {
      labelKey: 'timezone_offset_negative_0100',
      value: 'Atlantic/Cape_Verde',
      offset: -3600
    }, {
      labelKey: 'timezone_offset_0000',
      value: 'Europe/London',
      offset: 0
    }, {
      labelKey: 'timezone_offset_0100',
      value: 'Europe/Berlin',
      offset: 3600
    }, {
      labelKey: 'timezone_offset_0200',
      value: 'Asia/Beirut',
      offset: 7200
    }, {
      labelKey: 'timezone_offset_0300',
      value: 'Europe/Moscow',
      offset: 10800
    }, {
      labelKey: 'timezone_offset_0330',
      value: 'Asia/Tehran',
      offset: 12600
    }, {
      labelKey: 'timezone_offset_0400',
      value: 'Asia/Dubai',
      offset: 14400
    }, {
      labelKey: 'timezone_offset_0430',
      value: 'Asia/Kabul',
      offset: 16200
    }, {
      labelKey: 'timezone_offset_0500',
      value: 'Asia/Karachi',
      offset: 18000
    }, {
      labelKey: 'timezone_offset_0530',
      value: 'Asia/Kolkata',
      offset: 19800
    }, {
      labelKey: 'timezone_offset_0545',
      value: 'Asia/Kathmandu',
      offset: 20700
    }, {
      labelKey: 'timezone_offset_0600',
      value: 'Asia/Omsk',
      offset: 21600
    }, {
      labelKey: 'timezone_offset_0630',
      value: 'Asia/Rangoon',
      offset: 23400
    }, {
      labelKey: 'timezone_offset_0700',
      value: 'Asia/Jakarta',
      offset: 25200
    }, {
      labelKey: 'timezone_offset_0800',
      value: 'Asia/Irkutsk',
      offset: 28800
    }, {
      labelKey: 'timezone_offset_0845',
      value: 'Australia/Eucla',
      offset: 31500
    }, {
      labelKey: 'timezone_offset_0900',
      value: 'Asia/Tokyo',
      offset: 32400
    }, {
      labelKey: 'timezone_offset_0930',
      value: 'Australia/Darwin',
      offset: 34200
    }, {
      labelKey: 'timezone_offset_1000',
      value: 'Australia/Brisbane',
      offset: 36000
    }, {
      labelKey: 'timezone_offset_1030',
      value: 'Australia/Lord_Howe',
      offset: 37800
    }, {
      labelKey: 'timezone_offset_1100',
      value: 'Pacific/Noumea',
      offset: 39600
    }, {
      labelKey: 'timezone_offset_1130',
      value: 'Pacific/Norfolk',
      offset: 41400
    }, {
      labelKey: 'timezone_offset_1200',
      value: 'Pacific/Auckland',
      offset: 43200
    }, {
      labelKey: 'timezone_offset_1245',
      value: 'Pacific/Chatham',
      offset: 45900
    }, {
      labelKey: 'timezone_offset_1300',
      value: 'Pacific/Apia',
      offset: 46800
    }, {
      labelKey: 'timezone_offset_1400',
      value: 'Pacific/Kiritimati',
      offset: 50400
    }]
  },
  AU: {
    shouldSeeMagstripe: false,
    canSelectStateForProfile: true,
    shouldShowPostalCodeFieldForCards: false,
    shipping: 'australiaPost',
    rates: {
      swipe: 1.9,
      keyed: {
        percent: 1.9,
        constant: 0
      }
    },
    activeLanguages: ['en-AU'],
    feeTypes: [{
      value: 'au_gst',
      labelKey: 'GST'
    }],
    timezoneSelections: [{
      labelKey: 'perth',
      value: 'Australia/Perth',
      offset: 28800
    }, {
      labelKey: 'darwin',
      value: 'Australia/Darwin',
      offset: 34200
    }, {
      labelKey: 'adelaide',
      value: 'Australia/Adelaide',
      offset: 34200
    }, {
      labelKey: 'canberra',
      value: 'Australia/Canberra',
      offset: 36000
    }, {
      labelKey: 'melbourne',
      value: 'Australia/Melbourne',
      offset: 36000
    }, {
      labelKey: 'sydney',
      value: 'Australia/Sydney',
      offset: 36000
    }, {
      labelKey: 'brisbane',
      value: 'Australia/Brisbane',
      offset: 36000
    }, {
      labelKey: 'hobart',
      value: 'Australia/Hobart',
      offset: 36000
    }],
    closeOfDayHour: 0,
    // 12AM
    closeOfDayTimeZone: 'Australia/Melbourne'
  },
  CA: {
    shouldShowCanadianReceiptInfo: true,
    canSelectStateForProfile: true,
    canSeeHardwareUpsell: false,
    accountOwnerRoles: ['businessOwnerOrBusiness', 'coOwnerOrBusinessPartner', 'beneficialOwnerDirectorOrSimilar', 'ownerSpouseOrDomesticPartner', 'parentOrganization', 'other'],
    activeLanguages: ['en-CA', 'fr-CA'],
    feeTypes: [{
      value: 'ca_hst',
      labelKey: 'HST'
    }, {
      value: 'ca_gst',
      labelKey: 'GST'
    }, {
      value: 'ca_pst',
      labelKey: 'PST'
    }, {
      value: 'ca_qst',
      labelKey: 'QST'
    }],
    feeInclusionType: 'ADDITIVE',
    shipping: 'canadaPost',
    rates: {
      swipe: 2.75,
      keyed: {
        percent: 3.5,
        constant: 15
      }
    },
    institutions: [{
      labelKey: 'bankOfMontreal',
      number: '001'
    }, {
      labelKey: 'tdCanadaTrust',
      number: '004'
    }, {
      labelKey: 'royalBankOfCanada',
      number: '003'
    }, {
      labelKey: 'desjardins',
      number: '815'
    }, {
      labelKey: 'cibc',
      number: '010'
    }, {
      labelKey: 'scotiabank',
      number: '002'
    }, {
      labelKey: 'nationalBankOfCanada',
      number: '006'
    }, {
      labelKey: 'ing',
      number: '614'
    }, {
      labelKey: 'hsbc',
      number: '016'
    }],
    timezoneSelections: [{
      labelKey: 'newfoundland',
      value: 'America/St_Johns',
      offset: -10800
    }, {
      labelKey: 'atlantic',
      value: 'America/Halifax',
      offset: -14400
    }, {
      labelKey: 'eastern',
      value: 'America/Toronto',
      offset: -18000
    }, {
      labelKey: 'central',
      value: 'America/Winnipeg',
      offset: -21600
    }, {
      labelKey: 'saskatchewan',
      value: 'America/Regina',
      offset: -21600
    }, {
      labelKey: 'mountain',
      value: 'America/Edmonton',
      offset: -25200
    }, {
      labelKey: 'pacific',
      value: 'America/Vancouver',
      offset: -28800
    }]
  },
  JP: {
    canSelectStateForProfile: true,
    hasDepositAndWithdrawVerification: false,
    shouldHaveMinimumBalance: false,
    hasExtraBusinessNameFields: true,
    canQuerySplitDeposits: false,
    canVerifyBankIn2Days: true,
    canVerifyBankIn5Days: false,
    canDepositInBankByNextDay: false,
    cannotDepositInBankByNextDay: true,
    cannotSetReceiptsLanguage: true,
    canSetReceiptsLanguage: false,
    shouldShowPostalCodeFieldForCards: false,
    activeLanguages: ['ja', 'en'],
    feeTypes: [{
      value: 'jp_consumption_tax',
      labelKey: 'jpSalesTax'
    }],
    roundingType: 'TRUNCATE',
    bankAccountTypes: ['checking', 'savings', 'investment'],
    accountOwnerRoles: ['businessOwnerOrBusiness', 'coOwnerOrBusinessPartner', 'beneficialOwnerDirectorOrSimilar', 'parentOrganization', 'powerOfAttorneyOrGuardian', 'other'],
    shipping: 'other',
    rates: {
      swipe: 3.25,
      keyed: {
        percent: 3.75,
        constant: 0
      }
    },
    timezoneSelections: [{
      labelKey: 'japan',
      value: 'Asia/Tokyo',
      offset: 32400
    }]
  },
  GB: {
    canSeeTransactionTaxTable: true,
    shouldShowGreatBritainReceiptInfo: true,
    accountOwnerRoles: ['businessOwnerOrBusiness', 'coOwnerOrBusinessPartner', 'beneficialOwnerDirectorOrSimilar', 'other'],
    activeLanguages: ['en-GB'],
    feeTypes: [{
      value: 'vat',
      labelKey: 'VAT'
    }],
    closeOfDayHour: 0,
    // 12AM
    closeOfDayTimeZone: 'Europe/London',
    timezoneSelections: [{
      labelKey: 'timezone_offset_0000',
      value: 'Europe/London',
      offset: 0
    }]
  },
  ES: {
    shouldShowSpainReceiptInfo: true,
    shouldShowReceiptVatTable: true,
    accountOwnerRoles: ['businessOwnerOrBusiness', 'coOwnerOrBusinessPartner', 'beneficialOwnerDirectorOrSimilar', 'other'],
    activeLanguages: ['es-ES', 'ca-ES', 'en'],
    feeTypes: [{
      value: 'vat',
      labelKey: 'VAT'
    }],
    timezoneSelections: [{
      labelKey: 'madrid',
      value: 'Europe/Madrid',
      offset: 3600
    }]
  },
  FR: {
    shouldShowFranceReceiptInfo: true,
    shouldShowReceiptVatTable: true,
    canUseR12: true,
    accountOwnerRoles: ['businessOwnerOrBusiness', 'coOwnerOrBusinessPartner', 'beneficialOwnerDirectorOrSimilar', 'other'],
    activeLanguages: ['fr', 'en'],
    feeTypes: [{
      value: 'vat',
      labelKey: 'VAT'
    }],
    timezoneSelections: [{
      labelKey: 'paris',
      value: 'Europe/Paris',
      offset: 3600
    }]
  },
  IE: {
    canUseR12: true,
    accountOwnerRoles: ['businessOwnerOrBusiness', 'coOwnerOrBusinessPartner', 'beneficialOwnerDirectorOrSimilar', 'other'],
    activeLanguages: ['en-IE'],
    feeTypes: [{
      value: 'vat',
      labelKey: 'VAT'
    }],
    timezoneSelections: [{
      labelKey: 'dublin',
      value: 'Europe/Dublin',
      offset: 0
    }]
  },
  PT: {
    activeLanguages: ['pt-PT', 'en'],
    accountOwnerRoles: ['businessOwnerOrBusiness', 'coOwnerOrBusinessPartner', 'beneficialOwnerDirectorOrSimilar', 'other'],
    timezoneSelections: [{
      labelKey: 'lisbon',
      value: 'Europe/Lisbon',
      offset: 0
    }]
  },
  US: {
    canSelectStateForProfile: true,
    canUseR12: true,
    cannotSetReceiptsLanguage: true,
    canSetReceiptsLanguage: false,
    canUseSameDayDeposits: true,
    canUseWeekendBalance: true,
    activeLanguages: ['en-US', 'es-US'],
    feeTypes: [{
      value: 'us_sales_tax',
      labelKey: 'usSalesTax'
    }],
    accountOwnerRoles: ['businessOwnerOrBusiness', 'coOwnerOrBusinessPartner', 'beneficialOwnerDirectorOrSimilar', 'ownerSpouseOrDomesticPartner', 'parentOrganization', 'other'],
    feeInclusionType: 'ADDITIVE',
    shipping: 'usps',
    rates: {
      swipe: 2.75,
      keyed: {
        percent: 3.5,
        constant: 15
      },
      market: 2.75
    },
    timezoneSelections: [{
      labelKey: 'eastern',
      value: 'America/New_York',
      offset: -18000
    }, {
      labelKey: 'central',
      value: 'America/Chicago',
      offset: -21600
    }, {
      labelKey: 'mountain',
      value: 'America/Denver',
      offset: -25200
    }, {
      labelKey: 'arizona',
      value: 'America/Phoenix',
      offset: -25200
    }, {
      labelKey: 'pacific',
      value: 'America/Los_Angeles',
      offset: -28800
    }, {
      labelKey: 'alaska',
      value: 'America/Anchorage',
      offset: -32400
    }, {
      labelKey: 'hawaii',
      value: 'Pacific/Honolulu',
      offset: -36000
    }, {
      labelKey: 'samoa',
      value: 'Pacific/Pago_Pago',
      offset: -39600
    }]
  }
};